import React from 'react'
import { Sector } from 'src/shared/sectors.dto'
import { convertToKebabCase } from 'src/shared/utils'

export interface Props {
  sector: Sector
  className?: string
}

export const SectorLink: React.FC<Props> = ({ sector, className = '' }) => {
  return (
    <>
      <a
        className={className}
        href={`/sectors/${convertToKebabCase(sector.name)}-${sector.code}`}
      >
        {sector.name}
      </a>
    </>
  )
}
